import React from "react";
import { List, CreateButton } from "@refinedev/mui";
import { DataGrid } from "@shared/components/DataGrid";

import { CsvExportButton, FilterDropdown } from "@shared/components";

import { useNotificationsList } from "./controller";
import { useAgreementAppsListColumns } from "./columns";
import { AgreementAppListFilters } from "@modules/agreementApps/components/AgreementAppListFilters";

export const AgreementAppList = React.memo(() => {
  const {
    rows = [],
    loading,
    selectedRows,
    dataToExport,
    setSelectedRows,
    refetch,
    translate,
    tableProps,
  } = useNotificationsList();

  const columns = useAgreementAppsListColumns({
    onRefetch: refetch,
    translate,
  });

  return (
    <List
      headerButtons={
        <>
          <FilterDropdown
            initialValues={{
              search: "",
              for_agreement: "",
            }}
          >
            <AgreementAppListFilters />
          </FilterDropdown>
          <CsvExportButton
            data={dataToExport}
            filename="agreement_apps.csv"
            isLoading={loading}
            isDisabled={!rows?.length}
          />

          <CreateButton />
        </>
      }
    >
      <DataGrid
        {...tableProps}
        rows={rows}
        columns={columns}
        loading={loading}
        checkboxSelection
        rowSelectionModel={selectedRows}
        onRowSelectionModelChange={(selectionModel) =>
          setSelectedRows(selectionModel as number[])
        }
      />
    </List>
  );
});
